import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const textLabel = css`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${colors.NEUTRAL_10};
`;

export const textContent = css`
  margin-left: 8px;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${colors.NEUTRAL_10};
`;


export const styContainerExpandable = css`
padding: 12px;
margin: 0 -16px;
`